import React, {Component, Fragment} from 'react';
import {ModalBody, ModalFooter} from 'reactstrap';
import Modal from '../../../../shared/ui/Modal';
import ListActionSubheader from '../../common/ListActionSubheader';
import PropertyActions from '../../common/PropertyActions';
import AddActionButton from '../../common/AddActionButton';
import './TaskList.scss'
import TaskForm from "./TaskForm";
import {connect} from "react-redux";
import taskGroupsActions from "../../../store/task-groups/action-creators";
import TaskGroupForm from "../TaskGroupForm";
let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});

class TaskList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDeleteMessage: '',
      isModalOpen: false,
      isAddingTask: false,
      removeTaskGuid: null,
      editingTask: null,
      editingTaskGroup: null,
      isEditingTask: false,
      isEditingTaskGroup: false,
      isDeletingTaskGroup: false,
      deleteTaskGroupGuid: null,
    };
  }

  // ----------------------
  // Computed
  // ----------------------

  getTaskPropertyActions() {
    const removeTask = {
      label: 'Remove',
      handlerProp: 'onRemove',
      icon: 'trash',
    };
    const editTask = {
      label: 'Edit',
      handlerProp: 'onEdit',
      icon: 'edit',
    };
    return [editTask, removeTask];
  }

  // ----------------------
  // Methods
  // ----------------------

  openAddTask(taskGroup) {
    this.setState({
      currentTaskGroupGuid: taskGroup.taskGroupGuid,
      isAddingTask: true
    })
  }

  openEditTask(task) {
    this.setState({
      editingTask: task,
      isEditingTask: true
    })
  }

  closeAddTask() {
    this.setState({
      currentTaskGroupGuid: null,
      isAddingTask: false
    })
  }

  closeEditTaskGroup() {
    this.setState({
      editingTaskGroup: null,
      isEditingTaskGroup: false
    })
  }

  closeEditTask() {
    this.setState({
      editingTask: null,
      isEditingTask: false
    })
  }

  openEditTaskGroup(taskGroup) {
    this.setState({
      editingTaskGroup: taskGroup,
      isEditingTaskGroup: true
    })
  }

  updateTaskGroup(taskGroup) {
    const formData = {
      ...taskGroup,
      taskGroupGuid: this.state.editingTaskGroup.taskGroupGuid,
    };
    this.props.updateTaskGroup(formData)
      .then(() => this.closeEditTaskGroup())
      .then(() => this.props.onRefresh && this.props.onRefresh());
  }

  onSave(task) {
    const formData = {
      ...task,
      taskGroupGuid: this.state.currentTaskGroupGuid,
    };

    this.props.addTaskToTaskGroup(formData)
      .then(() => this.closeAddTask())
      .then(() => this.props.onRefresh && this.props.onRefresh());
  }

  onSaveEdit(task) {
    const formData = {
      ...task,
      taskGuid: this.state.editingTask.taskGuid,
    };
    this.props.updateTaskGroupTask(formData)
      .then(() => this.closeEditTask())
      .then(() => this.props.onRefresh && this.props.onRefresh());

  }

  taskGroupsSorted(taskGroups = []) {
    return taskGroups.sort(function (a, b) {
      return collator.compare(a.name, b.name);
    })
  }

  confirmRemoveTask(taskGuid, tasks) {
    const taskToRemove = (tasks || this.props.tasks).find((task) => {
      return task.taskGuid === taskGuid;
    });
    this.setState({
      confirmDeleteMessage: `Remove task labelled "${taskToRemove.prompt}"?`,
      isModalOpen: true,
      removeTaskGuid: taskGuid,
    });
  }

  removeTask(removeTaskGuid) {
    this.setState({
      confirmDeleteMessage: '',
      isModalOpen: false,
      removeTaskGuid: null,
    });
    this.props.onRemove(removeTaskGuid);
  }

  confirmDeleteTaskGroup(taskGroup) {
    this.setState({
      confirmDeleteMessage: `Delete Task Group draft labelled "${
        taskGroup.name
      }"?`,
      isDeletingTaskGroup: true,
      deleteTaskGroupGuid: taskGroup.taskGroupGuid,
    });
  }

  deleteTaskGroup(deleteTaskGuid) {
    this.setState({
      confirmDeleteMessage: '',
      isDeletingTaskGroup: false,
      deleteTaskGroupGuid: null,
    });
    this.props.deleteTaskGroup(deleteTaskGuid)
      .then(() => this.props.onRefresh && this.props.onRefresh());
  }

  sortedTasks(tasks) {
    return [...tasks].sort((a, b) => {
      return collator.compare(a.prompt, b.prompt)
    })
  }


  get tasks() {
    let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});

    return this.props.tasks
      .sort((a, b) => {
        if (!a.prompt.match(/^\d/) && !b.prompt.match(/^\d/)) {

          return 0;
        }
        return collator.compare(a.prompt, b.prompt)
      })
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        <ListActionSubheader title="Subcategories">
          {this.props.canAddEdit !== false && (
            <AddActionButton label="Subcategory" onAdd={() => this.props.onAddTaskGroup()} />
          )}
        </ListActionSubheader>
        {this.props.subGroups &&
          <div className="sub-groups">
            {this.taskGroupsSorted(this.props.subGroups).map(sg => (
              <div key={sg.taskGroupGuid} className="sub-group">
                <div className="sub-group-header">
                  <span style={{
                    whiteSpace: "pre-line",
                    unicodeBidi: "embed"
                  }}>{sg.name}</span>
                  {this.props.canAddEdit !== false && (
                    <div>
                      <PropertyActions
                        actions={this.getTaskPropertyActions()}
                        onEdit={() => this.openEditTaskGroup(sg)}
                        onRemove={() => this.confirmDeleteTaskGroup(sg)}
                      />
                      <span className="p-2"></span>
                      <AddActionButton label="Task" onAdd={() => this.openAddTask(sg)} />
                    </div>
                  )}
                </div>
                <div className="profile-list">
                  {sg.tasks.length > 0 ? (
                    this.sortedTasks(sg.tasks).map((task, index) => (
                      <div className="profile-list-item" key={task.taskGuid}>
                        <div className="profile-list-content">
                          <b>{task.prompt}</b> (Min responses: {task.min_responses})
                        </div>
                        <div className="profile-list-actions">
                          {this.props.canAddEdit !== false && (
                            <PropertyActions
                              actions={this.getTaskPropertyActions()}
                              onEdit={() => this.openEditTask(task)}
                              onRemove={() => this.confirmRemoveTask(task.taskGuid, sg.tasks)}
                            />
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="profile-list-item">No tasks found</div>
                  )}
                </div>
              </div>
            ))}
          </div>
        }

        <ListActionSubheader title="Tasks">

          {this.props.canAddEdit !== false && (
            <AddActionButton label="Task" onAdd={() => this.openAddTask(this.props.taskGroup)} />
          )}
        </ListActionSubheader>
        <div className="profile-list">
          {this.tasks.length > 0 ? (
            this.tasks.map((task, index) => (
              <div className="profile-list-item" key={index.toString()}>
                <div className="profile-list-content">
                  <b>{task.prompt}</b> (Min responses: {task.min_responses})
                </div>
                <div className="profile-list-actions">
                  {this.props.canAddEdit !== false && (
                    <PropertyActions
                      actions={this.getTaskPropertyActions()}
                      onEdit={() => this.openEditTask(task)}
                      onRemove={() => this.confirmRemoveTask(task.taskGuid)}
                    />
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="profile-list-item">No tasks found</div>
          )}
        </div>
        <Modal
          isOpen={this.state.isModalOpen}
          onClose={() => this.setState({ isModalOpen: false })}
          title="Confirm Remove Task"
        >
          <ModalBody>{this.state.confirmDeleteMessage}</ModalBody>
          <ModalFooter>
            <button
              className="button primary"
              onClick={() => this.removeTask(this.state.removeTaskGuid)}
            >
              Remove
            </button>
            <button
              className="button"
              onClick={() => this.setState({ isModalOpen: false })}
            >
              Cancel
            </button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.isAddingTask}
          title="Create Task"
          onClose={() => this.closeAddTask()}
        >
          {this.state.isAddingTask && <TaskForm
            onSave={(data) => this.onSave(data)}
          />}
        </Modal>
        <Modal
          isOpen={this.state.isEditingTask}
          title="Edit Task"
          onClose={() => this.closeEditTask()}
        >
          {this.state.isEditingTask &&
          <TaskForm
            initialValues={this.state.editingTask}
            onSave={(data) => this.onSaveEdit(data)}
          />}
        </Modal>
        <Modal
          isOpen={this.state.isEditingTaskGroup}
          title="Edit Task Group"
          onClose={() => this.closeEditTaskGroup()}
        >
          {this.state.isEditingTaskGroup &&
          <TaskGroupForm
            initialValues={this.state.editingTaskGroup}
            onSave={(data) => this.updateTaskGroup(data)}
          />}
        </Modal>
        <Modal
          isOpen={this.state.isDeletingTaskGroup}
          onClose={() => this.setState({isDeletingTaskGroup: false})}
          title="Confirm Delete Task Group Draft"
        >
          <ModalBody>{this.state.confirmDeleteMessage}</ModalBody>
          <ModalFooter>
            <button
              className="button primary"
              onClick={() => this.deleteTaskGroup(this.state.deleteTaskGroupGuid)}
            >
              Remove
            </button>
            <button
              className="button"
              onClick={() => this.setState({isDeletingTaskGroup: false})}
            >
              Cancel
            </button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addTaskToTaskGroup: formData =>
      dispatch(taskGroupsActions.addTaskToTaskGroup(formData)),
    updateTaskGroupTask: formData =>
      dispatch(taskGroupsActions.updateTaskGroupTask(formData)),
    updateTaskGroup: formData =>
      dispatch(taskGroupsActions.updateTaskGroup(formData)),
    deleteTaskGroup: (deleteTaskGuid) => {
      dispatch(taskGroupsActions.deleteTaskGroup(deleteTaskGuid));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskList);
